export default {"src":"/_next/static/media/hear-no-evil.119180ab.svg","height":21,"width":21};